// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import BuildPage from './pages/BuildPage';
import DownloadsPage from './pages/DownloadsPage';
import FlavorsPage from './pages/FlavorsPage';
import LoginPage from './pages/LoginPage';
import ExternalAuthPage from './pages/ExternalAuthPage';
import DashboardPage from './pages/DashboardPage';
import CustomAppsListPage from './pages/custom-apps/CustomAppsListPage';
import NewRequestPage from './pages/custom-apps/NewRequestPage';
import CustomAppDetailPage from './pages/custom-apps/CustomAppDetailPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { CurrentUserProvider } from './contexts/CurrentUserContext';
import { BuildLogProvider } from './contexts/BuildLogContext';
import BuildLogDock from './components/BuildLogDock';
import EndpointAccessGuard from './components/EndpointAccessGuard';
import AccessGate from './components/AccessGate';

function LegacySessionRedirect() {
  const { session_id } = useParams();
  return <Navigate to={`/builder/${encodeURIComponent(session_id)}`} replace />;
}

// Old bookmarks: the landing page moved into the dashboard, and #downloads into its own route.
function RootRedirect() {
  const { hash } = useLocation();
  return <Navigate to={hash === '#downloads' ? '/downloads' : '/dashboard'} replace />;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/external" element={<ExternalAuthPage />} />
          <Route path="*" element={(
            <EndpointAccessGuard>
              <CurrentUserProvider>
                <AccessGate>
                  <BuildLogProvider>
                  <Routes>
                    <Route path="/" element={<RootRedirect />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/custom-apps" element={<CustomAppsListPage />} />
                    <Route path="/custom-apps/new" element={<NewRequestPage />} />
                    <Route path="/custom-apps/:id" element={<CustomAppDetailPage />} />
                    <Route path="/flavors" element={<FlavorsPage />} />
                    <Route path="/builder" element={<BuildPage />} />
                    <Route path="/builder/:session_id" element={<BuildPage />} />
                    <Route path="/downloads" element={<DownloadsPage />} />
                    <Route path="/builds" element={<Navigate to="/builder" replace />} />
                    <Route path="/logs" element={<Navigate to="/builder" replace />} />
                    <Route path="/logs/:session_id" element={<LegacySessionRedirect />} />
                    <Route path="/companies" element={<Navigate to="/custom-apps" replace />} />
                    <Route path="/flavor-mappings" element={<Navigate to="/flavors" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                  <BuildLogDock />
                  </BuildLogProvider>
                </AccessGate>
              </CurrentUserProvider>
            </EndpointAccessGuard>
          )} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
